/***
 *
 *   BUTTON ICON STYLES
 *   The reference lays icon + label out with `gap-2` on the button itself
 *   rather than absolutely positioning the icon, so these keys only carry
 *   the shrink guard and the optional ordering.
 *
 **********/

const IconStyle = {
    base: 'shrink-0',
    fill: 'fill-current',

    // `alignRight` moves the icon after the label; the default is before it.
    alignRight: 'order-last',
    alignLeft: 'order-first',
};

export default IconStyle;
